import {faArrowLeft} from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import {faCreditCard} from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import {faMessages} from "@fortawesome/pro-solid-svg-icons/faMessages";
import {
    Button, ColourOutline, ColourSolid, DropdownMenu,
    FlexAlign,
    FlexGap,
    FlexJustify,
    ItemMenuEntry,
    Pill,
    StackHorizontal,
    StackVertical, useLayout, useTranslation
} from "@twigsby/frontend-framework";
import {FormatLocaleDate} from "@twigsby/helpers";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {useSite} from "../../../Providers/SiteInterfaceProvider";
import {SelectedMailMenuContent} from "../../Mail/Menus/SelectedMailMenuContent";

const MailItemHeader = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isMedium } = useLayout();
    const { currentLocale, UpdateSiteContact } = useSite();

    const { mailItemData, mailBoxInfo, mailItemOnHold, mailItemRequiresTopUp } = useMailbox();

    return (
        <StackHorizontal gap={FlexGap.Small} align={FlexAlign.Center}
                         justify={FlexJustify.Between}>
            <Button title={t('actions.goBack')}
                    onClick={() => navigate(-1)}
                    iconOnly={true}
                    icon={faArrowLeft}/>

            <StackVertical gap={FlexGap.ExtraSmall}>
                <h5 className={`m-0 ${mailItemData?.holdReason || mailItemRequiresTopUp ? 'text-white' : ''}`}>{mailItemData?.trackingId}</h5>

                {mailItemOnHold && (
                    <h6 className={'m-0 text-white'}>{t("mailItem.locked.title", { reason: mailItemData?.holdReason?.holdReasonDescription})}</h6>
                )}

                {mailItemRequiresTopUp && (
                    <h6 className={'m-0 text-white'}>{t('mailItem.messages.topUpRequired')}</h6>
                )}

                {!mailItemOnHold && !mailItemRequiresTopUp && (
                    <StackHorizontal gap={FlexGap.ExtraSmall} wrap={!isMedium}>
{/*                        {mailItemData?.actions.length === 1 && (
                            <Pill
                                content={`${mailItemData?.mailAction.description} ${mailItemData?.mailAction.status}`}
                                colour={ColourOutline.Success}
                            />
                        )}*/}

                        {mailItemData?.willBeIncludedInNextAutomaticForward && (
                            <Pill
                                content={t('mailItem.labels.inAutoForwarding')}
                                colour={ColourOutline.Secondary}
                            />
                        )}

                        {mailItemData?.clientFolder && (
                            <button
                                onClick={() => navigate(`/mail/custom-folder/${mailItemData.clientFolder?.id}`)}
                                className={`pill ${mailItemData?.clientFolder?.colour}`}
                            >
                                {`${t('labels.folder')}: ${mailItemData?.clientFolder?.description}`}
                            </button>
                        )}

                        {mailItemData?.mailAction?.status === 'pending' && (
                            <Pill
                                content={t('status.dynamicType', {action: `${mailItemData?.mailAction.description} ${mailItemData?.mailAction.status}` })}
                                colour={ColourOutline.Warning}
                            />
                        )}

                        {mailItemData?.daysUntilNextStorageCharge !== null && (
                            <Pill
                                content={t('mailItem.labels.storageCharges', { number: mailItemData?.daysUntilNextStorageCharge })}
                                colour={mailItemData?.daysUntilNextStorageCharge && mailItemData?.daysUntilNextStorageCharge <= 5 ? ColourOutline.Alert : ColourOutline.Secondary}
                            />
                        )}

                        {mailItemData?.mailLocationId !== undefined && (
                            <Pill
                                content={t('mailItem.labels.location', {location: mailItemData?.mailLocationId})}
                            />
                        )}

                        {mailItemData?.dateRead && (
                            <Pill
                                content={mailItemData?.mailLocationId === 7 ? t('mailItem.labels.dateCreated', { date: FormatLocaleDate(mailItemData?.dateUpdated, currentLocale) }) : t('mailItem.labels.dateRead', { date: FormatLocaleDate(mailItemData?.dateRead, currentLocale) })}
                            />
                        )}

                        <Pill
                            content={mailItemData?.dateReceived ? t('mailItem.labels.dateReceived', { date: FormatLocaleDate(mailItemData?.dateReceived, currentLocale) }) : ''}
                            colour={ColourOutline.Secondary}
                        />
                    </StackHorizontal>
                )}
            </StackVertical>


            {!isMedium && (
                <DropdownMenu
                    trigger={
                        <Button
                            title={t('mailboxes.mailActions.title')}
                            showArrow={true}
                            squared={true}
                            extraClass={'mail-item-menu ml-a'}
                        />
                    }
                >
                    {!mailItemOnHold && !mailItemRequiresTopUp && (
                        <>
                            <SelectedMailMenuContent
                                showCustomFolderRemove={!!mailBoxInfo.customFolderId && mailBoxInfo.customFolderId > -1}
                            />
                            <ItemMenuEntry title={t('labels.divider')} sectionDivider={true}/>
                        </>
                    )}
                    <ItemMenuEntry title={t('actions.messageUs')}
                                   onClick={() => UpdateSiteContact(true,2, undefined, `With regards to mail item: ${mailItemData?.trackingId}`)} icon={faMessages}/>
                </DropdownMenu>
            )}

            {mailItemRequiresTopUp && (
                <div className={'ml-a'}>
                    <Button
                        title={t('actions.topUp')}
                        onClick={() => navigate('/manage-account/payment/top-up')}
                        squared={true}
                        icon={faCreditCard}
                        colour={ColourSolid.Warning} />
                </div>
            )}

            {isMedium && !mailItemRequiresTopUp && (
                <div className={'ml-a'}>
                    <Button
                        title={t('actions.messageUs')}
                        onClick={() => UpdateSiteContact(true, 2, undefined, `With regards to mail item: ${mailItemData?.trackingId}`)}
                        squared={true}
                        icon={faMessages}
                        colour={mailItemData?.holdReason ? ColourSolid.Warning: ColourOutline.Secondary}/>
                </div>
            )}
        </StackHorizontal>
    )
}

export { MailItemHeader }
